import { isPathEk } from '@/utils/routes';
import ApiService from './ApiService';
import { COMMON_TYPE } from '@/types/enums';
import { ekDomain } from '@/configs/constants';

export default class AuthApi extends ApiService {
    // constructor() {
    //     super('system');
    // }

    login(payload) {
        return this.post('system/signin', payload, { noUseToken: true });
    }

    logout() {
        return this.post('signout');
    }

    confirmEmailForgetPassword(payload) {
        return this.post('users/forget-password', payload, { noUseToken: true });
    }

    // #region Register
    confirmEmailRegister(payload) {
        return this.post('users/confirm-email', payload, { noUseToken: true });
    }

    registerRD(payload) {
        return this.post('customer/gas/register', payload, { noUseToken: true });
    }

    registerEK(payload) {
        return this.post(`customer/${ekDomain}/register`, payload, { noUseToken: true });
    }

    uploadOcrNoToken(payload) {
        const type = isPathEk(window.location.pathname) ?
            COMMON_TYPE.EK :
            COMMON_TYPE.GAS;
        return this.post(`customer/ocr-license?type=${type}`, payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }
    // #endregion

    confirmPassword(payload) {
        return this.put('users/confirm-password', payload);
    }

    changePasswordEnduser(payload) {
        return this.put('customer/change-password', payload);
    }

    changePasswordCMS(payload) {
        const { id, ...rest } = payload;
        return this.put(`system/auth/change-password/${id}`, rest);
    }

    resetPasswordCMS(id) {
        return this.put(`system/auth/reset-password/${id}`);
    }

    checkUuid(payload) {
        return this.post('users/check/uuid', payload, { noUseToken: true });
    }

    verifyToken() {
        return this.get('auth/verify');
    }

    getProfile() {
        return this.get('profile');
    }

    // #region Change email enduser
    changeEmailEnduser(payload) {
        const { id, email } = payload;
        return this.put(`users/change-email/${id}`, { email });
    }
}
